import React from 'react';

import DataTable from '../../shared/data_table';
import StatusPill from '../../shared/status_pill';

/*
 * PROD-7828 R9 — the persisted preview, one line per file row with its verdict and every code on it
 * (not only the first), so Ops can fix the whole file in one pass. Props-only; rows are upload_row_view.
 */
const PreviewTable = ({ rows }) => {
  const columns = [
    { key: 'line', label: 'Row' },
    {
      key: 'verdict',
      label: 'Result',
      render: (r) => <StatusPill tone={r.verdict_tone}>{r.verdict_label}</StatusPill>
    },
    {
      key: 'teacher_name',
      label: 'Teacher',
      render: (r) => (
        <span>
          <b>{r.teacher_name}</b>
          {r.teacher_sub ? <div className="tp-card-field-label">{r.teacher_sub}</div> : null}
        </span>
      )
    },
    { key: 'category_label', label: 'Category' },
    { key: 'amount_text', label: 'Amount', align: 'right' },
    { key: 'entry_text', label: 'Entry date' },
    { key: 'reference_id', label: 'Reference' },
    // The teacher sees this note on the payment email.
    { key: 'note', label: 'Note', render: (r) => r.note || '—' },
    {
      key: 'issues',
      label: 'Issues',
      render: (r) =>
        r.issues.length || r.lookalikes.length ? (
          <ul className="tp-dup-list">
            {/* One code can appear twice on a row (two INVALID_REQUEST fields): keys carry the index. */}
            {r.issues.map((i, n) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={`issue-${n}-${i.code}`} data-code={i.code}>
                {i.text}
              </li>
            ))}
            {r.lookalikes.map((text, n) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={`lookalike-${n}`}>{text}</li>
            ))}
          </ul>
        ) : (
          '—'
        )
    }
  ];
  return (
    <DataTable
      columns={columns}
      rows={rows}
      rowKey={(r) => r.key}
      cardTitle={(r) => (
        <span>
          Row {r.line} · <StatusPill tone={r.verdict_tone}>{r.verdict_label}</StatusPill>
        </span>
      )}
      emptyText="No rows match this filter."
    />
  );
};

export default PreviewTable;
